module.exports = __webpack_public_path__ + "static/media/HCMM916.3eaa0ead.jpg";